import { render, staticRenderFns } from "./Form321_v2.vue?vue&type=template&id=252dfc9c&scoped=true&"
import script from "./Form321_v2.vue?vue&type=script&lang=js&"
export * from "./Form321_v2.vue?vue&type=script&lang=js&"
import style0 from "./Form321_v2.vue?vue&type=style&index=0&id=252dfc9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252dfc9c",
  null
  
)

export default component.exports